export default "__VITE_ASSET__CSVjJ4Sq__"